import { EquipUIFireflyV2Theme, RiskLevel } from '@equip.health/ui';

import { SurveyBadge } from '~/components/maud/patients/profile/common/SurveyBadge';

/**
 * @deprecated
 */
const RiskLevelColors: Partial<
  Record<RiskLevel, { bgColor: string; labelColor: string }>
> = {
  [RiskLevel.NOT_CALCULATED]: {
    bgColor: 'neutral.line',
    labelColor: 'neutral.primary',
  },
  [RiskLevel.NONE]: {
    bgColor: 'neutral.secondary',
    labelColor: 'neutral.line',
  },
  [RiskLevel.HIGH]: {
    bgColor: 'critical.base',
    labelColor: 'neutral.primary',
  },
  [RiskLevel.LOW]: {
    bgColor: 'primary.10',
    labelColor:
      EquipUIFireflyV2Theme.colors.background.button['primary.active'],
  },
  [RiskLevel.MILD]: {
    bgColor: 'secondary.10',
    labelColor: 'secondary.70',
  },
  [RiskLevel.MEDIUM]: {
    bgColor: 'tertiary.marigold.base',
    labelColor: 'neutral.primary',
  },
  [RiskLevel.MODERATE]: {
    bgColor: 'tertiary.marigold.base',
    labelColor: 'neutral.primary',
  },
  [RiskLevel.MODERATELY_SEVERE]: {
    bgColor: 'tertiary.marigold.base',
    labelColor: 'neutral.primary',
  },
};

type SurveyRiskBadgeProps = {
  riskLevel: RiskLevel;
  id: string;
  label: string;
};

export const SurveyRiskBadge = ({
  riskLevel,
  id,
  label,
}: SurveyRiskBadgeProps) => {
  const { bgColor, labelColor } = RiskLevelColors[riskLevel];
  return (
    <SurveyBadge
      bgColor={bgColor}
      id={id}
      label={label}
      labelColor={labelColor}
    />
  );
};
